import { ErrorHandler, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class MutaraErrroHandler implements ErrorHandler {
  constructor() {
  }
  handleError(error: Error) {
    if (!!error) {
      // Blind audit 
      console.error('UI:Error  %O', error);
      if (!environment?.production && !!error?.stack) {
        let stack = error?.stack.split('\n');
        console.error(stack.filter(row => row.includes('main') || row.includes('Mutara/')));
      }
    }
  }
}